export default __webpack_public_path__ + "static/media/hp-prev-program-01-desktop.b7dce41a.jpg";